<template>
    <a
        v-on:click.prevent="$emit('togglePasswordState')"
        class="password-reveal-button"
        href="#"
        title="Password anzeigen/verbergen"
    >
        <img
            v-show="!passwordIsRevealed"
            class="password-reveal-button__image-reveal"
            src="/files/static/ui/icons/icon_eye.svg"
            ref="svginjectReveal"
            alt="Password anzeigen"
        />
        <img
            v-show="passwordIsRevealed"
            class="password-reveal-button__image-hide"
            src="/files/static/ui/icons/icon_eye_cross.svg"
            ref="svginjectHide"
            alt="Password verbergen"
        />
    </a>
</template>

<script>
import SVGInject from '@iconfu/svg-inject';

export default {
    data() {
        return {};
    },
    components: {},
    methods: {},
    computed: {},
    created() {},
    props: {
        passwordIsRevealed: Boolean
    },
    mounted() {
        SVGInject(this.$refs.svginjectReveal);
        SVGInject(this.$refs.svginjectHide);
    }
};
</script>
